const BANK_META: Record<string, { bg: string; letter: string; label: string; logo?: string }> = {
  hdfc: { bg: "#004c8f", letter: "H", label: "HDFC", logo: "/bank-logos/hdfc.png" },
  icici: { bg: "#b02a30", letter: "I", label: "ICICI", logo: "/bank-logos/icici.png" },
  sbi: { bg: "#22338b", letter: "S", label: "SBI", logo: "/bank-logos/sbi.png" },
  amex: { bg: "#006fcf", letter: "A", label: "AMEX", logo: "/bank-logos/amex.png" },
  kotak: { bg: "#9c1f2f", letter: "K", label: "Kotak", logo: "/bank-logos/kotak.png" },
}

function getMeta(bank: string) {
  return (
    BANK_META[bank.toLowerCase()] ?? {
      bg: "#2d2d29",
      letter: bank.charAt(0).toUpperCase(),
      label: bank.toUpperCase(),
    }
  )
}

interface BankChipProps {
  bank: string
  size?: "sm" | "md"
}

export function BankChip({ bank, size = "md" }: BankChipProps) {
  const meta = getMeta(bank)
  const px = size === "sm" ? 32 : 40
  const radius = size === "sm" ? 8 : 10

  if (meta.logo) {
    return (
      <img
        src={meta.logo}
        alt={meta.label}
        title={meta.label}
        style={{
          width: px,
          height: px,
          borderRadius: radius,
          objectFit: "contain",
          background: "#fff",
          padding: size === "sm" ? 3 : 4,
          flexShrink: 0,
        }}
      />
    )
  }

  const fontSize = size === "sm" ? 12 : 15
  return (
    <div
      style={{
        width: px,
        height: px,
        background: meta.bg,
        borderRadius: radius,
        display: "grid",
        placeItems: "center",
        color: "#fff",
        fontWeight: 700,
        fontSize,
        flexShrink: 0,
      }}
    >
      {meta.letter}
    </div>
  )
}
